import React from "react";

import { IBynderRiveAnimation } from "@brexhq/shared/types/BynderAsset";

import { RiveAnimation } from "../../RiveAnimation/riveAnimation";
import { StyledRiveAnimationProps } from "../../RiveAnimation/types";

const BynderRiveAnimation: React.FC<
  IBynderRiveAnimation & StyledRiveAnimationProps
> = React.forwardRef<
  HTMLCanvasElement,
  IBynderRiveAnimation & StyledRiveAnimationProps
>(
  (
    {
      originalUrl: riveUrl,
      aspectRatio,
      thumbnailUrl,
      previewImg,
      playbackButton,
      play,
      animationProgress,
      onProgressUpdate,
      handleSetActiveSlide,
    },
    ref,
  ) => {
    return (
      <RiveAnimation
        ref={ref}
        thumbnailUrl={thumbnailUrl}
        originalUrl={riveUrl}
        aspectRatio={aspectRatio}
        type="DOCUMENT"
        previewImg={previewImg}
        play={play}
        playbackButton={playbackButton}
        animationProgress={animationProgress}
        onProgressUpdate={onProgressUpdate}
        handleSetActiveSlide={handleSetActiveSlide}
      />
    );
  },
);

BynderRiveAnimation.displayName = "BynderRiveAnimation";

export default BynderRiveAnimation;
